const tendenciasRoutes = [
  {
    path: "/tendencias",
    name: "tendencias.index",
    component: () => import("@/modules/tendencias/views/MercadoLivreTrends.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
      pageTitle: "Mix Inteligente",
    },
  },
  {
    path: "/tendencias/mercado-livre",
    redirect: { name: "tendencias.index" },
  },
];

export default tendenciasRoutes;
